import React from 'react'
import TextField from '@mui/material/TextField'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'

const DatePicker = ({
	label,
	onChange,
	value,
	disabled,
	...rest
}) => (
	<LocalizationProvider dateAdapter={AdapterMoment}>
		<DateTimePicker
			ampm={false}
			ampmInClock={false}
			disabled={disabled}
			renderInput={(props) => <TextField
				variant='filled'
				margin='dense'
				InputLabelProps={{ shrink: true }}
				{...props} />}
			label={label}
			value={value}
			onChange={(date) => onChange(date)}
		/>
	</LocalizationProvider>
)

export default DatePicker
